module.exports = {"roverBaseUrl":"http://localhost:5000","logLevel":"debug"}


//////////////////
// WEBPACK FOOTER
// ./src/config/development.json
// module id = 528
// module chunks = 5